module.exports = { raw: '8.10.1' };



//////////////////
// WEBPACK FOOTER
// /var/www/dnata-cerf-front-end/releases/20200326161233/~/auth0-js/src/version.js
// module id = VJ25
// module chunks = 4